import React, { useContext } from "react";
import { HexRadioItem } from "../../components/RadioItem";
import { HexpertContext, unitSytems } from "../../contexts/HexPertProvider";
import { UnitSystem } from "../../helpers/unitsConversion";
import './WeFitFormHeaderBlock.scss';

const unitSystemToName = (unit: UnitSystem) => {
  const { state } = useContext(HexpertContext);
  switch (unit) {
    case UnitSystem.IMPERIAL:
      return state.pageProps.HexpertImperialRadioButton;
    case UnitSystem.METRIC:
      return state.pageProps.HexpertMetricRadioButton;
    default:
      return state.pageProps.HexpertStandardRadioButton;
  }
};

export const WeFitFormHeaderBlock = () => {
  const { state, dispatch } = useContext(HexpertContext);

  return (
    <div className="c-hex-form-header-block">
      <div className="c-hex-form-header-wrapper">
        <p className="c-hex-form-header-block-title">{state.pageProps.HexpertUnitsLabel}</p>
        {unitSytems.map((unit) => {
          return (
            <HexRadioItem
              key={unit}
              label={unitSystemToName(unit)}
              name={"units"}
              onChange={() => {
                dispatch({ type: "setUnit", payload: unit });
              }}
              value={unit}
              selected={state.unitSystem === unit}
            />
          );
        })}
      </div>
    </div>
  );
};
